/* eslint-disable */

// Version: 2.8.6
// https://github.com/DevExpress/DevExtreme.AspNet.Data
// Copyright (c) Developer Express Inc.

/* global define, module, require */

window.modelTemplate = {
    editModelTemplate: {},
    createModelTemplate: {},
    parentModel: {},
    additionalFilters: [],
};

(function (factory) {
    "use strict";

    function unwrapESModule(module) {
        return module && module.__esModule && module.default ? module.default : module;
    }

    if (typeof define === "function" && define.amd) {
        define(function (require, exports, module) {
            module.exports = factory(
                unwrapESModule(require("devextreme/core/utils/ajax")),
                require("devextreme/core/utils/deferred").Deferred,
                require("devextreme/core/utils/extend").extend,
                unwrapESModule(require("devextreme/data/custom_store")),
                unwrapESModule(require("devextreme/data/utils"))
            );
        });
    } else if (typeof module === "object" && module.exports) {
        module.exports = factory(
            unwrapESModule(require("devextreme/core/utils/ajax")),
            require("devextreme/core/utils/deferred").Deferred,
            require("devextreme/core/utils/extend").extend,
            unwrapESModule(require("devextreme/data/custom_store")),
            unwrapESModule(require("devextreme/data/utils"))
        );
    } else {
        throw "This script should be used with an AMD or CommonJS loader";
    }

})(function (ajaxUtility, Deferred, extend, CustomStore, dataUtils) {
    "use strict";

    var CUSTOM_STORE_OPTIONS = [
        "onLoading", "onLoaded",
        "onInserting", "onInserted",
        "onUpdating", "onUpdated",
        "onRemoving", "onRemoved",
        "onModifying", "onModified",
        "onPush",
        "loadMode", "cacheRawData",
        "errorHandler"
    ];

    function createStoreConfig(options, gridRenderKey, api) {
        var keyExpr = options.key,
            loadUrl = options.loadUrl,
            getEditUrl = options.getEditUrl,
            loadMethod = options.loadMethod || "GET",
            getEditMethod = options.getEditMethod || 'GET',
            getCreateMethod = options.getCreateMethod || 'GET',
            loadParams = options.loadParams,
            isRawLoadMode = options.loadMode === "raw",
            updateUrl = options.updateUrl,
            saveUrl = options.saveUrl,
            saveCopyUrl = options.saveCopyUrl,
            getCreateUrl = options.getCreateUrl,
            deleteUrl = options.deleteUrl,
            deleteAllUrl = options.deleteAllUrl,
            onBeforeSend = options.onBeforeSend,
            onAjaxError = options.onAjaxError;

        function getErrorMessage(error) {
            return `Не удалось получить данные с сервера`;
        }

        function send(operation, requiresKey, ajaxSettings, customSuccessHandler, api) {
            var d = Deferred(),
                thenable,
                beforeSendResult;

            let customParams = options.customParams;

            function sendCore() {
                ajaxSettings.params = {}
                if (ajaxSettings.method == "GET")
                    ajaxSettings.params = { ...ajaxSettings.data };

                const parentModel = window.modelTemplate.parentModel[gridRenderKey];
                if (parentModel && parentModel.id != null) {
                    ajaxSettings.params["IdParent"] = parentModel.id;
                }
                if (customParams) {
                    for (let key in customParams) {
                        ajaxSettings.params[key] = customParams[key];
                    }
                }
                api.request(ajaxSettings).then((res) => {
                    if (customSuccessHandler)
                        customSuccessHandler(d, res);
                    d.resolve(res);
                }).catch((err) => {
                    const error = err.response;
                    if (onAjaxError)
                        onAjaxError(err);

                    d.reject(getErrorMessage(err));
                });
            }

            if (requiresKey && !keyExpr) {
                d.reject(new Error("Primary key is not specified (operation: '" + operation + "', url: '" + ajaxSettings.url + "')"));
            } else {
                if (operation === "load") {
                    ajaxSettings.cache = false;
                    ajaxSettings.dataType = "json";
                } else {
                    if (operation === 'getCreate' || operation === 'getEdit') {
                        ajaxSettings.dataType = 'text';
                    } else {
                        ajaxSettings.cache = false;
                        ajaxSettings.dataType = 'json';
                    }
                }

                //для обновления и создания на сервере должно быть FromBody и application/json
                if (operation == 'update' || operation == 'insert') {
                    ajaxSettings.dataType = 'json';
                    ajaxSettings.contentType = 'application/json';
                }

                if (onBeforeSend) {
                    beforeSendResult = onBeforeSend(operation, ajaxSettings);
                    if (beforeSendResult && typeof beforeSendResult.then === "function")
                        thenable = beforeSendResult;
                }

                if (thenable)
                    thenable.then(sendCore, function (error) { d.reject(error); });
                else
                    sendCore();
            }

            return d.promise();
        }

        function filterByKey(keyValue) {
            if (!Array.isArray(keyExpr))
                return [keyExpr, keyValue];

            return keyExpr.map(function (i) {
                return [i, keyValue[i]];
            });
        }

        function getUrlWithParams(urlStr, paramsObj) {
            var url = new URL(window.location.protocol + '//' + window.location.host + urlStr),
                params = paramsObj;
            Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
            return url;
        }

        function loadOptionsToActionParams(options, isCountQuery) {
            var result = {};

            if (isCountQuery)
                result.isCountQuery = isCountQuery;

            if (options) {

                ["skip", "take", "requireTotalCount", "requireGroupCount"].forEach(function (i) {
                    if (options[i] !== undefined)
                        result[i] = options[i];
                });

                var normalizeSorting = dataUtils.normalizeSortingInfo,
                    group = options.group,
                    filter = options.filter,
                    select = options.select;

                if (options.sort)
                    result.sort = JSON.stringify(normalizeSorting(options.sort));

                if (group) {
                    if (!isAdvancedGrouping(group))
                        group = normalizeSorting(group);
                    result.group = JSON.stringify(group);
                }

                var additionalFilters = window.modelTemplate.additionalFilters[gridRenderKey];
                if (Array.isArray(filter)) {

                    if (additionalFilters && additionalFilters.length > 0) {
                        filter = [filter, "and", additionalFilters];
                    }
                    filter = extend(true, [], filter);
                    stringifyDatesInFilter(filter);
                    result.filter = JSON.stringify(filter);
                } else {
                    if (additionalFilters && additionalFilters.length > 0) {
                        filter = additionalFilters;
                        filter = extend(true, [], filter);
                        stringifyDatesInFilter(filter);
                        result.filter = JSON.stringify(filter);
                    }
                }

                if (options.totalSummary)
                    result.totalSummary = JSON.stringify(options.totalSummary);

                if (options.groupSummary)
                    result.groupSummary = JSON.stringify(options.groupSummary);

                if (select) {
                    if (!Array.isArray(select))
                        select = [select];
                    result.select = JSON.stringify(select);
                }
            }

            extend(result, loadParams);

            return result;
        }

        var result = {
            key: keyExpr,
            useDefaultSearch: true,

            load: function (loadOptions) {
                return send(
                    "load",
                    false,
                    {
                        url: loadUrl,
                        method: loadMethod,
                        data: loadOptionsToActionParams(loadOptions)
                    },
                    function (d, res) {
                        processLoadResponse(d, res, function (res) {
                            return [res.data, createLoadExtra(res)];
                        });
                    }, api
                );
            },

            totalCount: !isRawLoadMode && function (loadOptions) {
                return send(
                    "load",
                    false,
                    {
                        url: loadUrl,
                        method: loadMethod,
                        data: loadOptionsToActionParams(loadOptions, true)
                    },
                    function (d, res) {
                        processLoadResponse(d, res, function (res) {
                            return [res.totalCount];
                        });
                    }, api
                );
            },

            byKey: !isRawLoadMode && function (key) {
                return send(
                    "load",
                    true,
                    {
                        url: loadUrl,
                        method: loadMethod,
                        data: loadOptionsToActionParams({ filter: filterByKey(key) })
                    },
                    function (d, res) {
                        processLoadResponse(d, res, function (res) {
                            return [res.data[0]];
                        });
                    }, api
                );
            },

            getEdit:
                !isRawLoadMode &&
                function (key) {
                    const params = { id: key };
                    const parentModel = window.modelTemplate.parentModel[gridRenderKey];
                    if (parentModel && parentModel.id != null)
                        params["IdParent"] = parentModel.id;
                    return api.request({
                        url: getUrlWithParams(getEditUrl, params),
                        method: getEditMethod,
                    })
                        .then((res) => {
                            return res.data;
                        })
                        .catch((d) => {
                            throw 'Ошибка загрузки данных с сервера';
                        });
                },

            getCreate:
                !isRawLoadMode &&
                function () {
                    const params = {};
                    const parentModel = window.modelTemplate.parentModel[gridRenderKey];
                    if (parentModel && parentModel.id != null)
                        params["IdParent"] = parentModel.id;

                    return api.request({
                        url: getUrlWithParams(getCreateUrl, params),
                        method: getCreateMethod,
                    })
                        .then(res => {
                            return res.data;
                        })
                        .catch((e) => {
                            throw 'Ошибка загрузки данных с сервера';
                        });
                },

            update:
                updateUrl &&
                function (key, values) {
                    let obj = window.modelTemplate.editModelTemplate[gridRenderKey];
                    Object.assign(obj, values);
                    return send(
                        'update',
                        true,
                        {
                            url: updateUrl,
                            method: options.updateMethod || 'PUT',
                            data: JSON.stringify(obj),
                        },
                        function (d, res) {
                            return d.resolve(res);
                        }, api
                    );
                },

            insert:
                saveUrl &&
                getCreateUrl &&
                function (values) {
                    let obj = window.modelTemplate.createModelTemplate[gridRenderKey];

                    Object.assign(obj, values);
                    return send(
                        'insert',
                        true,
                        {
                            url: saveUrl,
                            method: options.saveMethod || 'POST',
                            data: JSON.stringify(obj),
                        },
                        function (d, res) {
                            return d.resolve(res);
                        }, api
                    );
                },

            saveCopy:
                saveCopyUrl &&
                function (values) {
                    let obj = window.modelTemplate.createModelTemplate[gridRenderKey];

                    Object.assign(obj, values);
                    return send(
                        'saveCopy',
                        true,
                        {
                            url: saveCopyUrl,
                            method: options.saveMethod || 'POST',
                            data: JSON.stringify(obj),
                        },
                        function (d, res) {
                            return d.resolve(res);
                        }, api
                    );
                },

            remove: deleteUrl && function (key) {
                const params = {};
                const parentModel = window.modelTemplate.parentModel[gridRenderKey];
                if (parentModel && parentModel.id != null)
                    params["IdParent"] = parentModel.id;

                var bodyFormData = new FormData();
                bodyFormData.append('id', key);
                return api.request({
                    url: deleteUrl,
                    method: options.deleteMethod || "DELETE",
                    data: bodyFormData,
                    params: params
                })
                    .then((res) => {
                        return res.data;
                    })
                    .catch(() => {
                        throw 'Ошибка загрузки данных с сервера';
                    });
            },

            removeAll: deleteAllUrl && function () {
                const params = {};
                const parentModel = window.modelTemplate.parentModel[gridRenderKey];
                if (parentModel && parentModel.id != null)
                    params["IdParent"] = parentModel.id;
                return api.request({
                    url: deleteAllUrl,
                    method: options.deleteMethod || "DELETE",
                    params: params
                })
                    .then((res) => {
                        return res.data;
                    })
                    .catch(() => {
                        throw 'Ошибка загрузки данных с сервера';
                    });
            }

        };

        CUSTOM_STORE_OPTIONS.forEach(function (name) {
            var value = options[name];
            if (value !== undefined)
                result[name] = value;
        });

        return result;
    }

    function processLoadResponse(d, res, getResolveArgs) {
        res = expandLoadResponse(res);

        if (!res || typeof res !== "object")
            d.reject(new Error("Unexpected response received"));
        else
            d.resolve.apply(d, getResolveArgs(res));
    }

    function expandLoadResponse(value) {
        if (Array.isArray(value))
            return { data: value };

        if (typeof value === "number")
            return { totalCount: value };

        return value;
    }

    function createLoadExtra(res) {
        return {
            totalCount: "totalCount" in res ? res.totalCount : -1,
            groupCount: "groupCount" in res ? res.groupCount : -1,
            summary: res.summary || null
        };
    }

    /*function serializeKey(key) {
        if(typeof key === "object")
            return JSON.stringify(key);
  
        return key;
    }*/

    function serializeDate(date) {

        function zpad(text, len) {
            text = String(text);
            while (text.length < len)
                text = "0" + text;
            return text;
        }

        var builder = [1 + date.getMonth(), "/", date.getDate(), "/", date.getFullYear()],
            h = date.getHours(),
            m = date.getMinutes(),
            s = date.getSeconds(),
            f = date.getMilliseconds();

        if (h + m + s + f > 0)
            builder.push(" ", zpad(h, 2), ":", zpad(m, 2), ":", zpad(s, 2), ".", zpad(f, 3));

        return builder.join("");
    }

    function stringifyDatesInFilter(crit) {
        crit.forEach(function (v, k) {
            if (Array.isArray(v)) {
                stringifyDatesInFilter(v);
            } else if (Object.prototype.toString.call(v) === "[object Date]") {
                crit[k] = serializeDate(v);
            }
        });
    }

    function isAdvancedGrouping(expr) {
        if (!Array.isArray(expr))
            return false;

        for (var i = 0; i < expr.length; i++) {
            if ("groupInterval" in expr[i] || "isExpanded" in expr[i])
                return true;
        }

        return false;
    }

    /*function getErrorMessageFromXhr(xhr) {
        var mime = xhr.getResponseHeader("Content-Type"),
            responseText = xhr.responseText;
  
        if(!mime)
            return null;
  
        if(mime.indexOf("text/plain") === 0)
            return responseText;
  
        if(mime.indexOf("application/json") === 0) {
            var jsonObj = safeParseJSON(responseText);
  
            if(typeof jsonObj === "string")
                return jsonObj;
  
            if(typeof jsonObj === "object") {
                for(var key in jsonObj) {
                    if(typeof jsonObj[key] === "string")
                        return jsonObj[key];
                }
            }
  
            return responseText;
        }
  
        return null;
    }*/

    function safeParseJSON(json) {
        try {
            return JSON.parse(json);
        } catch (x) {
            return null;
        }
    }

    return {
        createStore: function (options, gridRenderKey, api) {
            var config = createStoreConfig(options, gridRenderKey, api);
            var customStore = new CustomStore(config);
            customStore.getCreate = config.getCreate;
            customStore.getEdit = config.getEdit;
            customStore.removeAll = config.removeAll;
            customStore.saveCopy = config.saveCopy;
            return customStore;
        },

        setEditModel: function (gridRenderKey, editModel) {
            window.modelTemplate.editModelTemplate[gridRenderKey] = editModel;
        },

        setCreateModel: function (gridRenderKey, createModel) {
            window.modelTemplate.createModelTemplate[gridRenderKey] = createModel;
        },

        getEditModel: function (gridRenderKey) {
            return window.modelTemplate.editModelTemplate[gridRenderKey];
        },

        getCreateModel: function (gridRenderKey) {
            return window.modelTemplate.createModelTemplate[gridRenderKey];
        },

        setParentModel: function (gridRenderKey, parentModel) {
            window.modelTemplate.parentModel[gridRenderKey] = parentModel;
        },

        getParentModel: function (gridRenderKey) {
            return window.modelTemplate.parentModel[gridRenderKey];
        },

        setAdditionalFilters: function (gridRenderKey, additionalFilters) {
            window.modelTemplate.additionalFilters[gridRenderKey] = additionalFilters;
        },

        getAdditionalFilters: function (gridRenderKey) {
            return window.modelTemplate.additionalFilters[gridRenderKey];
        },
    };
});
